<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">历史统计
          <span v-if="camName"> - {{camName}}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding-top:1rem;padding-bottom:2rem;">
        <div style="box-shadow:0 0 14px 0 rgba(0,0,0,.08);">
          <v-card flat style="padding-bottom:0.2rem;">
            <div style="padding:0.5rem;padding-bottom:0;font-size:0.8rem;position: relative;">
              最近7天历史统计
            </div>
            <v-divider style="margin-top:0.5rem;" />
            <E7dayStat ref="day_stat" id="chart1" :data="weekStatData" />
          </v-card>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import E7dayStat from './components/E7dayStat';
export default {
  components: { E7dayStat },
  props: {},
  data() {
    return {
      weekStatData: {
        labels: ['06-06', '06-07', '06-08', '06-09', '06-10', '06-11', '06-12'],
        values: [0, 0, 0, 0, 0, 0, 0]
      },
      seqCode: '',
      camName: ''
    };
  },
  watch: {
  },
  computed: {},
  mounted() {
    var that = this;
    if (that.$route.query.seq_code) {
      that.seqCode = that.$route.query.seq_code
    } else {
      var staffInfo = that.$AppHelper.getCustomData('staff_info');
      that.camName = staffInfo.USER_NAME
    }
    if (that.$route.query.cam_name) {
      that.camName = that.$route.query.cam_name
    }

    that.$nextTick(() => {
      that.getLast7DayStat()
    })
    that.windowSize()
  },
  created() {},
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    goBack: function() {
      var that = this;
      that.$router.goBack()
    },
    getLast7DayStat() {
      var that = this
      that.$api.bz.stat7DayCamImage({ seq_code: that.seqCode }).then(res => {
        if (!res.success) {
          console.log('获取最近7天历史数据失败', res);
          return
        }
        that.weekStatData = res.data
      })
    },
    windowSize() {
      var that = this
      // 监听窗口大小
      window.onresize = () => {
        return (() => {
          that.$nextTick(() => {
            that.$refs.day_stat.reloadSize()
          })
        })()
      }
    }
  }
};
</script>

<style scoped>

.us-v-app{
  background-color: #f2f2f2;
}

.us-back-lucency {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #fff !important;
  cursor: pointer;
  box-shadow: 1px 1px 5px 1px rgba(255, 255, 255, 0.4) !important;
}
.us-lucency-border {
  border-top: 1px solid #f5f5f5;
}
.v-menu__content {
  background: #fff;
}
</style>
